module.exports = __webpack_public_path__ + "img/image-20.ea25f18c.webp";